import { Body } from './Body'
import { TileCheckbox } from './Checkbox'
import { Container } from './Container'
import { TileProvider } from './Context'
import { Footer } from './Footer'
import { Header } from './Header'
import { Label } from './Label'
import { Root } from './Root'
import { Row } from './Row'
import { StatusPill } from './StatusPill'
import { Title } from './Title'
import { Value } from './Value'

export const Tile = {
  StatusPill,
  Root,
  Checkbox: TileCheckbox,
  Provider: TileProvider,
  Body,
  Footer,
  Header,
  Row,
  Label,
  Value,
  Title,
  Container,
}
